import { Col, Form, Row } from 'antd';
import { ButtonFilter } from 'components';
import ButtonExport from 'components/Button/ButtonExport';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import FilterHandover, { HandOverStatusEnum } from './FilterHandover';
import TableHandover from './TableHandover';
import { useNavigate } from 'react-router-dom';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import dayjs from 'dayjs';
import { useUser } from 'contexts/UserProvider';
import { useTitle } from 'contexts/TitleProvider';
import ModalHandover from './ModalHandover';
import { useMutation } from '@tanstack/react-query';
import { HandoverApis } from 'apis/HandoverApis';
import { exportExcel_v2 } from 'utils/constants/exportExcel';
import { toastError, toastSuccess } from 'utils/constants/functions';

const HandoverPage = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { setTitle, setBreadcrumb } = useTitle();
  const childRef = useRef<any>(null);
  const [isOpenFilter, setIsOpenFilter] = useState(true);
  const [formParams, setFormParams] = useState<any>({});
  const [isOpenedModalHandover, setIsOpenedModalHandover] = useState(false);
  const [dataModal, setDataModal] = useState<any>({});
  const [data, setData] = useState<any>({});

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const defaultFilter = useMemo(() => {
    const defaultF = {
      // fromDateToDate: [
      //   dayjs().month(9).year(2024).startOf('month'),
      //   dayjs().date(31).month(9).year(2024).endOf('month'),
      // ],
      fromDateToDate: [dayjs().startOf('month'), dayjs()],
      // status: HandOverStatusEnum.CHUA_BAN_GIAO,
    };

    if (user?.isAdmin || user?.isHO)
      return {
        ...defaultF,
      };

    return {
      plantId: user?.plantCode,
      ...defaultF,
    };
  }, [user]);

  const mutateGetHandover = useMutation({
    mutationFn: HandoverApis.getListHandover,
    onSuccess: (res: any, variables) => {
      const result = res?.data?.getHandOverList;
      if (variables.type === 'export') {
        exportExcel_v2(variables.headerRow, result?.items, 'Bàn giao');
      } else {
        setData(result);
      }
    },
    onError: (error: any) => {
      console.log('error', error);
    },
  });

  const refetchGetHandover = useCallback(
    async (isExport?: boolean, headerRow?: any) => {
      try {
        await mutateGetHandover.mutateAsync({
          page: isExport ? 1 : page,
          page_size: isExport ? data?.pageInfo?.totalItems || 1000 : page_size,
          ...(defaultFilter && defaultFilter),
          ...(formParams && formParams),
          ...(isExport && {
            headerRow,
            type: 'export',
          }),
        });
      } catch (error) {
        console.log('mutateGetHandover', error);
      }
    },
    [page, page_size, formParams, defaultFilter, data?.pageInfo?.totalItems],
  );

  useEffect(() => {
    refetchGetHandover();
  }, [refetchGetHandover]);

  const mutateConfirmHandover = useMutation({
    mutationFn: HandoverApis.confirmHandover,
    onSuccess: (res: any, variables) => {
      console.log('res', res);
      const result = res?.data?.createHandOver;
      if (result?.success) {
        setFormParams({ ...formParams });
        toastSuccess(result?.message);
      } else {
        toastError(result?.message);
      }
    },
    onError: (error: any) => {
      console.log('error', error);
    },
  });

  useEffect(() => {
    setTitle('Bàn giao');
    setBreadcrumb([{ title: 'Kế toán/Thủ quỹ' }, { title: 'Bàn giao' }]);
  }, [setTitle, setBreadcrumb]);

  const handleExportExcel = () => {
    if (childRef.current) {
      childRef.current.exportExcel();
    }
  };

  const handleOkFilter = useCallback(
    (values: any) => {
      // console.log(values);
      navigate(`?page=1&page_size=${page_size}`);
      setFormParams(values);
    },
    [page_size],
  );

  const handleCancelFilter = useCallback(() => {
    setFormParams({});
  }, []);

  const handleOnClickHandover = (record: any) => {
    setIsOpenedModalHandover(true);
    setDataModal(record);
  };

  const handleFormConfirm = (values: any) => {
    console.log('handleFormConfirm', {
      teamSalesId: values?.teamSalesId,
      routeId: values?.routeId,
      customerId: values?.customerId,
      plantId: values?.plantId,
      implementationDate: values?.implementationEndDate,
      q10: values?.totalQ10,
      finalPrice: values?.totalFinalPrice,
      ...(user?.isStorekeeper
        ? {
            warehouseAdminister: user?.id,
            handOverQ10: values?.confirm,
          }
        : {
            treasurerId: user?.id,
            handOverFinalPrice: values.confirm,
          }),
      // treasurerId: '34',
      // q10: 50,
      // handOverQ10: 50,
    });
    setIsOpenedModalHandover(false);
    mutateConfirmHandover.mutate({
      teamSalesId: values?.teamSalesId,
      routeId: values?.routeId,
      customerId: values?.customerId,
      plantId: values?.plantId,
      implementationDate: values?.implementationEndDate,
      q10: values?.totalQ10,
      finalPrice: values?.totalFinalPrice,
      ...(user?.isStorekeeper
        ? {
            warehouseAdminister: user?.id,
            handOverQ10: values?.confirm,
          }
        : {
            treasurerId: user?.id,
            handOverFinalPrice: values.confirm,
          }),
      // treasurerId: '34',
      // q10: 50,
      // handOverQ10: 50,
    });
    // refetchGetHandover();
  };

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter isOpen={isOpenFilter} setIsOpen={setIsOpenFilter} />
        </Col>
        <Col>
          <ButtonExport onClick={handleExportExcel} />
        </Col>
      </Row>
      <FilterHandover
        isOpen={isOpenFilter}
        defaultFilter={defaultFilter}
        onFinish={handleOkFilter}
        onCancel={handleCancelFilter}
      />
      <TableHandover
        ref={childRef}
        data={data}
        loading={mutateGetHandover.isPending}
        refetch={refetchGetHandover}
        handleOnClickHandover={handleOnClickHandover}
      />
      <ModalHandover
        isOpen={isOpenedModalHandover}
        setIsOpen={setIsOpenedModalHandover}
        data={dataModal}
        handleOk={handleFormConfirm}
      />
    </>
  );
};

export default HandoverPage;
